import { useDatasetCheckScreen } from "./useDatasetCheckScreen";
import { PreviewBlock } from "./components/PreviewBlock";
import { DetailsBlock } from "./components/DetailsBlock";

export const DatasetCheckScreen = ({
  show = false,
  dataset = null,
  validationData = null,
  onSuccessValidationRefresh = () => {},
  datasetLoading = false,
}) => {
  const {
    showDetails,
    checkState,
    setShowDetails,
    showDatasetInfo,
    setShowDatasetInfo,
    datasetName,
    onContinueClick,
  } = useDatasetCheckScreen({ show, dataset, validationData, onSuccessValidationRefresh, datasetLoading });

  return (
    <>
      {!showDetails ? (
        <PreviewBlock
          {...{
            checkState,
            setShowDetails,
            showDatasetInfo,
            setShowDatasetInfo,
            datasetName,
            onContinueClick,
            isPopup: !!dataset,
          }}
        />
      ) : (
        <DetailsBlock
          {...{
            showDetails,
            name: datasetName,
            data: checkState?.[showDetails] || null,
            setShowDetails,
            isPopup: !!dataset,
          }}
        />
      )}
    </>
  );
};
